import React from 'react';
import './styles/UserList.css';

const UserListFilters = ({ filters, setFilters }) => {
  const handleFilterChange = (filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  };

  return (
    <div className="userListFiltersGrid" aria-label="User filters">
      <div className="userListField">
        <label htmlFor="userFilterStatus">Status</label>
        <select
          id="userFilterStatus"
          className="userListSelect"
          value={filters.status}
          onChange={(e) => handleFilterChange('status', e.target.value)}
        >
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="blocked">Blocked</option>
          <option value="pending">Pending</option>
        </select>
      </div>

      <div className="userListField">
        <label htmlFor="userFilterRole">Role</label>
        <select
          id="userFilterRole"
          className="userListSelect"
          value={filters.role}
          onChange={(e) => handleFilterChange('role', e.target.value)}
        >
          <option value="all">All</option>
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
      </div>

      <div className="userListField">
        <label htmlFor="userFilterDateRange">Created</label>
        <select
          id="userFilterDateRange"
          className="userListSelect"
          value={filters.dateRange}
          onChange={(e) => handleFilterChange('dateRange', e.target.value)}
        >
          <option value="all">All time</option>
          <option value="today">Today</option>
          <option value="week">This week</option>
          <option value="month">This month</option>
          <option value="year">This year</option>
        </select>
      </div>

      <div className="userListField">
        <label htmlFor="userFilterInactive">Activity</label>
        <select
          id="userFilterInactive"
          className="userListSelect"
          value={filters.inactive}
          onChange={(e) => handleFilterChange('inactive', e.target.value)}
        >
          <option value="all">Any activity</option>
          <option value="30">Inactive ≥ 30 days</option>
          <option value="60">Inactive ≥ 60 days</option>
          <option value="90">Inactive ≥ 90 days</option>
        </select>
      </div>
    </div>
  );
};

export default UserListFilters; 